/** @jsxImportSource @emotion/react */
import { useState } from 'react'
import Typography from '@mui/material/Typography'
import Collapse from '@mui/material/Collapse'
import groupBy from 'lodash/groupBy'
import { findAllPlatforms_findAllPlatforms_items as PlatformType } from '__generatedTypes__/findAllPlatforms'
import { PlatformName } from '__generatedTypes__/globalTypes'
import PlatformList, { getFullPlatformTitle } from '../PlatformList'
import { ReactComponent as LogoIcon } from '../icons/logo.svg'
import { ReactComponent as DATCrusherLogoIcon } from '../icons/datcrusher-logo.svg'
import { ReactComponent as ToggleIcon } from '../icons/toggle.svg'
import * as classes from './styles'

const getLogo = (platform?: PlatformName) => {
  if (platform === PlatformName.DATCrusher) {
    return DATCrusherLogoIcon
  }
  return LogoIcon
}

type Props = {
  selectedPlatformKey: string
  platforms: Array<PlatformType & { key: string }>
  onCloseMenu: () => void
}

export const PlatformSelector = ({ selectedPlatformKey, platforms, onCloseMenu }: Props) => {
  const [isMenuExpanded, setIsMenuExpanded] = useState(false)
  const handleToggleMenu = () => setIsMenuExpanded((prev) => !prev)

  const platformsGroups = groupBy(platforms, 'category')

  const selectedPlatform = platforms.find(({ key }) => key === selectedPlatformKey)
  const Logo = getLogo(selectedPlatform?.title)

  return (
    <>
      <div>
        <div onClick={handleToggleMenu} css={classes.productsSelector(isMenuExpanded)}>
          <div css={classes.logoContainer}>
            <Logo css={classes.logo} />
            <div css={classes.selectedPlatformBlock}>
              <Typography css={classes.selectedPlatformTitle}>Booster CMS</Typography>
              <Typography css={classes.selectedPlatformDescription}>
                {getFullPlatformTitle(selectedPlatform?.title)}
              </Typography>
            </div>
          </div>
          <ToggleIcon />
        </div>
      </div>

      <div>
        <Collapse in={isMenuExpanded}>
          <div css={classes.platformsInnerWrapper}>
            {Object.entries(platformsGroups).map(([platformCategory, platforms]) => (
              <PlatformList
                key={platformCategory}
                selectedPlatformKey={selectedPlatformKey}
                platformCategory={platformCategory}
                platforms={platforms}
                closeMenu={() => {
                  setIsMenuExpanded(false)
                  onCloseMenu()
                }}
              />
            ))}
          </div>
        </Collapse>
      </div>
    </>
  )
}

export default PlatformSelector
